import Footer from "./views/components/Footer";
import Profile from "./views/components/Profile";
import Skill from "./views/components/Skill";
import GalleryCards from "./views/components/Gallery";
import SNS from "./views/components/SNS";
import Header from "./views/components/Header";
import Loading from "./views/components/Loading";
import { Container } from "@mui/material";
import { useState } from "react";

function Main(props) {
  const loading = props.loading;
  const setLoading = props.setLoading;
  const portfolioMode = props.portfolioMode;
  const setPortfolioMode = props.setPortfolioMode;
  
  return (
    <div className={loading ? "App" : "App curtain"}>
      <Header loading={loading} setLoading={setLoading} />
      {!loading && (
        <>
          <Profile portfolioMode={portfolioMode} setPortfolioMode={setPortfolioMode} />
          <Container maxWidth={false}>
            <Skill portfolioMode={portfolioMode} />
            <GalleryCards portfolioMode={portfolioMode} />
            {portfolioMode === "engineer" && <SNS />}
          </Container>
          <Footer />
        </>
      )}
    </div>
  );
}

function App() {
  const [loading, setLoading] = useState(true);
  const [portfolioMode, setPortfolioMode] = useState("engineer"); // "engineer" or "illustrator"

  return (
    <>
      {loading && <Loading />}
      <Main 
        loading={loading} 
        setLoading={setLoading}
        portfolioMode={portfolioMode}
        setPortfolioMode={setPortfolioMode}
      />
    </>
  );
}

export default App;
